import React, { FunctionComponent, ReactNode } from "react";

export interface IconBaseProps {
  children: ReactNode;
  size?: string;
  viewBoxSize?: string;
  className?: string;
  color?: string;
}

const IconBase: FunctionComponent<IconBaseProps> = ({
  children,
  size = "16",
  viewBoxSize = "24",
  color = "#6b6b6b",
  ...options
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      {...options}
    >
      {children}
    </svg>
  );
};

export default IconBase;
